var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaved(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8 2.07803H3.2C2.59249 2.07803 2.1 2.56069 2.1 3.15607V19.8396C2.1 20.8479 3.38641 21.3044 4.04504 20.5298L9.46487 14.1558C10.7842 12.6043 13.2158 12.6043 14.5351 14.1558L19.955 20.5298C20.6136 21.3044 21.9 20.8479 21.9 19.8396V3.15607C21.9 2.56069 21.4075 2.07803 20.8 2.07803ZM3.2 1C1.98497 1 1 1.9653 1 3.15607V19.8396C1 21.8562 3.57281 22.7691 4.89008 21.2199L10.3099 14.846C11.1895 13.8116 12.8105 13.8116 13.6901 14.846L19.1099 21.2199C20.4272 22.7691 23 21.8562 23 19.8396V3.15607C23 1.96531 22.015 1 20.8 1H3.2Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaved);
export default __webpack_public_path__ + "static/media/Saved.31556d46.svg";
export { ForwardRef as ReactComponent };